import fetch from '@adc/fetch'
import configment from '@adc/configment'
import type { Maybe, UserVerification } from '@adc/sdk/types'
import _ from 'lodash'

const initiateIdentityVerification = () =>
  fetch(
    `${configment.get('RESI_MS_PROFILE')}/resi/profile/v1/id-verification/`,
    {
      method: 'POST',
      headers: {
        // propertyReport endpoint returns plaintext so we need this to prevent JSON.parsing this
        Accept: '*/*',
      },
    }
  )

const performProcessIdUploadVerification = () =>
  fetch
    .fromService('RESI_MS_PROFILE')
    .post(`/resi/profile/v1/id-verification/process-id-uploaded`)
    .then(res => res.body)

const fetchUserVerificationStatus = async () =>
  fetch
    .forAuctionGraph<
      'current_user',
      { verification_status: Maybe<UserVerification> }
    >({
      query: `
        query resiRegistration_getVerificationStatus {
          current_user {
            verification_status {
              internal_verification_status
              redirect_url
              total_verification_attempts
              reject_reason
              display_name
            }
          }
        }
      `,
    })
    .then(res => {
      const errors = _.get(res, 'body.errors[0]')
      // We allow partial errors so long as some information about a user was returned
      if (errors && !res.body.data?.current_user?.verification_status)
        throw errors
      return res.body.data?.current_user?.verification_status
    })

export {
  initiateIdentityVerification,
  performProcessIdUploadVerification,
  fetchUserVerificationStatus,
}
